<header class="header">
  <div class="header__inner">
    <!-- Which partner's panel this is: the name the backend answered with at sign-in. -->
    <span class="header__partner" data-testid="header-partner">
      Partner: {{ partnerLabel() }}
    </span>

    <a class="header__brand" [routerLink]="['/', partnerSlug()]" aria-label="Marketplace — home">
      <img
        class="header__logotype"
        src="/assets/images/logo.svg"
        alt=""
        width="30"
        height="30"
        />
      <span class="header__title">Marketplace</span>
    </a>

    <div class="header__side-right">
      <app-theme-toggle class="header__theme" />

      <button
        class="header__logout"
        mat-icon-button
        type="button"
        aria-label="Log out"
        (click)="logout()"
        >
        <i class="material-icons" aria-hidden="true">logout</i>
      </button>
    </div>
  </div>
</header>
